import {
  AfterContentInit,
  Component,
  ContentChildren,
  DestroyRef,
  EventEmitter,
  inject,
  input,
  Input,
  OnDestroy,
  Output,
  QueryList,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxTabModule } from '../tab/tab.module';
import { TabItemComponent } from './tab-item/tab-item.component';
import { Observable, Subject, takeUntil } from 'rxjs';
import { DatepickerTab } from '../../constants/datepicker-tab.enum';
import { IconSvgComponent } from '../icon/icon.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'rx-tab-group',
  standalone: true,
  imports: [CommonModule, RxTabModule, TabItemComponent, IconSvgComponent],
  templateUrl: './tab-group.component.html',
  styleUrl: './tab-group.component.scss',
})
export class TabGroupComponent implements AfterContentInit {
  @ContentChildren(TabItemComponent) tabs: QueryList<TabItemComponent> = new QueryList();
  @Input({ required: true }) resetSelectedTab$: Observable<boolean>;
  @Output() tabChange: EventEmitter<DatepickerTab> = new EventEmitter<DatepickerTab>(); //specific for datepicker
  @Output() tabClick: EventEmitter<TabItemComponent & { index: number }> = new EventEmitter<
    TabItemComponent & { index: number }
  >();
  @Input({ required: false }) hideLabelsOnMobile = false;
  @Input({ required: false }) setSelectedTab$: Observable<number>;
  @Input({ required: false }) homePageStyles = false;

  fillSpaceItems = input(true);

  destroyRef = inject(DestroyRef);

  ngAfterContentInit(): void {
    const activeTabs: TabItemComponent[] = this.tabs.filter((tab: TabItemComponent) => tab.selected);
    if (!activeTabs.length) {
      this.activateTab(this.tabs.first);
    }

    if (this.resetSelectedTab$) {
      this.resetSelectedTab$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((): void => this.activateTab(this.tabs.first));
    }

    if (this.setSelectedTab$) {
      this.setSelectedTab$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((index: number): void => this.activateTab(this.tabs.toArray()[index], index));
    }
  }

  activateTab(tab: TabItemComponent, index?: number): void {
    const activeTab: TabItemComponent | undefined = this.tabs.toArray().find((tab) => tab.selected);

    this.tabs.toArray().forEach((item: TabItemComponent): boolean => (item.selected = false));
    tab.selected = true;
    if (activeTab && activeTab.tabId !== tab.tabId) {
      this.tabChange.emit(tab.tabId);
    }

    if (index !== undefined && index !== null) {
      this.tabClick.emit({ ...tab, index });
    }
  }
}
